import React, { useEffect, useState } from "react";
import { withFormik, Form, Field } from "formik";
import { Link } from "react-router-dom";
import { auth } from "../../utils/firebase";
import { toast } from "react-toastify";

const validate = (values, props) => {
  let errors = {};
  if (!values.userName) {
    errors.userName = "Enter a username";
  }
  if (!values.password) {
    errors.password = "Enter a password";
  }
  return errors;
};

const handleSignin = (values) => {
  const { userName, password } = values;
  return auth()
    .signInWithEmailAndPassword(userName, password)
    .catch((error) => {
      toast.error("mmmmmmmmmm no");
    });
};

const LoginComponent = (props) => {
  const {
    values,
    handleChange,
    dirty,
    errors,
    touched,
    isSubmitting,
    status = { locked: false, error: null },
    setStatus,
  } = props;

  const [capsLock, setCapsLock] = useState(false);

  // useEffect(() => {
  //   document.getElementById("userName").focus();
  // }, []);

  useEffect(() => {
    document.title = "Cookbook App";
  }, []);

  useEffect(() => {
    setStatus({ locked: false, error: null });
  }, []);

  const handleKeyDown = (e) => {
    const checkLock = e.getModifierState("CapsLock");
    setCapsLock(checkLock);
  };

  return (
    <div className="d-flex flex-column align-items-center">
      <div className="form-container">
        <h2>Login</h2>
        <Form className="App-form" onKeyDown={handleKeyDown}>
          <div
            className={
              "form-group form-group-lg " +
              (errors.userName && touched.userName ? "has-error" : "")
            }
          >
            <label htmlFor="userName" className="control-label">
              Username <span className="text-danger">*</span>
            </label>
            <Field
              id="userName"
              type="userName"
              className="form-control"
              name="userName"
              value={values.userName}
              onChange={handleChange}
            />
            {errors.userName && touched.userName && (
              <div className="text-danger exception-margin" role="alert">
                <span
                  className="glyphicon glyphicon-exclamation-sign"
                  aria-hidden="true"
                ></span>
                <span className="sr-only">Error:</span>
                {touched.userName && errors.userName}
              </div>
            )}
          </div>
          <div
            className={
              "form-group form-group-lg " +
              (errors.password && touched.password ? "has-error" : "")
            }
          >
            <label htmlFor="password" className="control-label">
              Password <span className="text-danger">*</span>
            </label>
            <Field
              type="password"
              className="form-control"
              name="password"
              value={values.password}
              onChange={handleChange}
            />
            {capsLock && (
              <div className="exception-margin">
                <span className="text-warning" role="alert">
                  <span
                    className="glyphicon glyphicon-warning-sign"
                    aria-hidden="true"
                  ></span>
                  <span className="sr-only">Caps Lock is ON</span>
                </span>
                Caps Lock is ON
              </div>
            )}
            {errors.password && touched.password && (
              <div
                className={
                  capsLock ? "text-danger" : "text-danger exception-margin"
                }
                role="alert"
              >
                <span
                  className="glyphicon glyphicon-exclamation-sign"
                  aria-hidden="true"
                ></span>
                <span className="sr-only">Error:</span>
                {touched.password && errors.password}
              </div>
            )}
          </div>
          {/* <div className="form-group form-group-lg">
            <label htmlFor="rememberMe">
              <Field
                className="App-rememberMe"
                type="checkbox"
                name="rememberMe"
                checked={values.rememberMe}
              ></Field>{" "}
              Remember Me
            </label>
          </div> */}
          <button
            type="submit"
            className="btn btn-primary btn-lg btn-block"
            disabled={!dirty || isSubmitting || status.locked}
          >
            Login
          </button>
        </Form>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            width: "100%",
            minHeight: "40px",
            padding: "5px 0",
          }}
        >
          {/* <div style={{ display: "flex", flexWrap: "wrap" }}>
            <Link to="/forgot-password" style={{ paddingRight: "5px" }}>
              Forgot Password |
            </Link>

            <Link to="/forgot-username">Forgot Username</Link>
          </div> */}
          {/* <p className="highlightText">
            Don't have an account?{" "}
            <Link to="/cookbook/registration">Register</Link>{" "}
          </p> */}
        </div>
      </div>
    </div>
  );
};

const Login = withFormik({
  mapPropsToValues({ userName, password, rememberMe }) {
    const uName = window.localStorage.getItem("uName");

    if (uName) {
      userName = uName;
      rememberMe = true;
    }
    return {
      userName: userName || "",
      password: password || "",
      rememberMe: rememberMe || false,
    };
  },
  validate: validate,
  handleSubmit(values, { props, setSubmitting, setStatus }) {
    return handleSignin(values);
    // .then((response) => {
    //   if (values.rememberMe) {
    //     window.localStorage.setItem("uName", values.userName);
    //   } else {
    //     window.localStorage.removeItem("uName");
    //   }
    //   if (response && response.data) {
    //     props.setAccessToken(response.data.access_token);
    //   }
    //   window.localStorage.removeItem(values.userName);
    //   setSubmitting(false);
    // })
    // .catch((error) => {
    //   const maxLoginAttempts = 5;
    //   const loginAttempts = window.localStorage.getItem(values.userName)
    //     ? parseInt(window.localStorage.getItem(values.userName)) + 1
    //     : 1;
    //   if (maxLoginAttempts >= loginAttempts) {
    //     // TODO: set localStorage value with timestamp to temporarily disable login functionality
    //     console.log("TOO MANY ATTEMPTS");
    //   }
    //   props.showNotification({
    //     type: "failure",
    //     title: "Login failed",
    //     message: `You fail login`,
    //   });
    // });
  },
})(LoginComponent);

export default Login;
